<template src="./ContactSelect.html"></template>

<script>
export default {
  name: 'ContactSelect',
  compatConfig: {
    COMPONENT_V_MODEL: false
  },
  props: {
    modelValue: { type: Object, default: null },
    options: { type: Array, default: function () { return [] } },
    placeholder: { type: String, default: 'Search...' },
    loading: { type: Boolean, default: false },
    /** Optional custom display function for options. Falls back to company/name/first+last + address. */
    display: { type: Function, default: null },
    /** When true, input is readonly and the control acts as a static field (no @search emitted). */
    readonly: { type: Boolean, default: false },
    /** Show clear (x) when a value is selected (search mode). */
    clearable: { type: Boolean, default: true }
  },
  data: function () {
    return {
      searchText: '',
      open: false
    }
  },
  computed: {
    showClear: function () {
      return this.clearable && !this.readonly && this.modelValue && (this.modelValue.id != null || this.modelValue.uuid != null)
    }
  },
  watch: {
    modelValue: {
      immediate: true,
      handler: function (v) {
        if (v) {
          this.searchText = this.getDisplayName(v)
        } else {
          this.searchText = ''
        }
      }
    }
  },
  methods: {
    getBaseName: function (opt) {
      if (!opt) return ''
      if (opt.company) return String(opt.company).trim()
      if (opt.name) return String(opt.name).trim()
      const full = ((opt.first_name || '') + ' ' + (opt.last_name || '')).trim()
      return full || String(opt.id || opt.uuid || '')
    },
    getDisplayName: function (opt) {
      if (!opt) return ''
      if (typeof this.display === 'function') return this.display(opt)
      const name = this.getBaseName(opt)
      const street = opt.street_address ? String(opt.street_address).trim() : ''
      const suburb = opt.suburb ? String(opt.suburb).trim() : ''
      const addr = [street, suburb].filter(Boolean).join(', ')
      if (addr) return name + ' (' + addr + ')'
      return name
    },
    onTextInput: function (value) {
      if (this.readonly) return
      this.searchText = value
      // Typing clears a previous selection so parent does not keep a stale contact
      if (this.modelValue && (this.modelValue.id != null || this.modelValue.uuid != null)) {
        this.$emit('update:modelValue', null)
      }
      this.open = true
      this.$emit('search', this.searchText)
    },
    onBlur: function () {
      var self = this
      setTimeout(function () { self.open = false }, 150)
    },
    openDropdown: function () {
      if (!this.readonly) this.open = true
    },
    closeDropdown: function () {
      this.open = false
    },
    select: function (opt) {
      this.$emit('update:modelValue', opt)
      this.searchText = this.getDisplayName(opt)
      this.open = false
    },
    clear: function () {
      this.$emit('update:modelValue', null)
      this.searchText = ''
      this.open = false
      this.$emit('search', '')
    }
  }
}
</script>

<style scoped>
.contact-select {
  position: relative;
}
.contact-select__field {
  position: relative;
}
.contact-select__field.has-clear :deep(.smardie-text-input input) {
  padding-right: 2.5rem;
}
/* Match Quotes / Invoices / Customers list search fill inside this control */
.contact-select :deep(.smardie-text-input input) {
  background: var(--color-bg-input) !important;
  color: var(--color-text) !important;
  -webkit-text-fill-color: var(--color-text);
  border-color: var(--color-border-input) !important;
}
.contact-select :deep(.smardie-text-input input::placeholder) {
  color: var(--color-text-muted) !important;
  -webkit-text-fill-color: var(--color-text-muted);
  opacity: 1 !important;
}
.contact-select__clear {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  border: none;
  background: transparent;
  padding: 0.35rem;
  margin: 0;
  cursor: pointer;
  color: var(--color-primary);
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.contact-select__clear .icon {
  margin: 0;
  color: var(--color-primary);
}
.contact-dropdown {
  /* In-flow so parent modals expand instead of clipping an absolute list */
  position: relative;
  z-index: 2;
  max-height: 220px;
  overflow-y: auto;
  margin-top: 4px;
  background: var(--color-bg-surface);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  box-shadow: var(--shadow-tile);
  box-sizing: border-box;
}
.contact-dropdown__loader {
  margin: 12px;
}
.contact-dropdown__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.contact-dropdown__item {
  cursor: pointer;
  list-style: none;
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 8px 12px;
  margin: 0;
  line-height: 1.25;
  box-sizing: border-box;
  color: var(--color-text);
}
.contact-dropdown__item:hover {
  background: var(--color-very-light-grey);
  color: var(--color-text);
}
[data-theme="dark"] .contact-dropdown__item:hover {
  background: var(--color-charcoal);
  color: var(--color-text);
}
</style>
